
import { defineComponent } from 'vue';
import JSShare from 'js-share';
import BizIcon from '@/components/base/BizIcon.vue';

export default defineComponent({
    components: { BizIcon },
    props: {
        contrast: {
            type: Boolean,
            default: false
        },
        share: {
            type: String
        }
    },
    data() {
        return {
            hidden: true,
            icons: this.getShareIcons(),
            open: false
        };
    },
    mounted() {
        for (let i = 0; i < this.$refs.shareItems.length; i += 1) {
            this.$refs.shareItems[i].addEventListener('click', function share() {
                if (this.dataset.type === 'xing') {
                    // custom handler for xing since its not supported by the library
                    const url = `https://www.xing.com/spi/shares/new?url=${encodeURIComponent(
                        location.href
                    )}`;
                    window.open(url, '_blank');
                    return;
                }
                if (this.dataset.type === 'telegram') {
                    const url = `https://t.me/share/url?url=${encodeURIComponent(
                        location.href
                    )}&text=${encodeURIComponent(document.title)}`;
                    window.open(url, '_blank');
                    return;
                }
                if (this.dataset.type === 'wechat') {
                    navigator.clipboard.writeText(location.href);
                    return;
                }
                return JSShare.go(this);
            });
        }
    },
    methods: {
        getShareIcons() {
            const baseIcons = ['facebook', 'linkedin', 'whatsapp', 'telegram', 'email'];
            const locale = document.documentElement.lang || '';
            if (locale.startsWith('zh')) {
                return [...baseIcons, 'wechat', 'douyin'];
            }
            return baseIcons;
        },
        copy() {
            navigator.clipboard.writeText(location.href);
        },
        print() {
            window.print();
        }
    },
    watch: {
        hidden(newValue) {
            if (newValue) {
                this.open = false;
            }
        }
    }
});
